import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const TechnicianColumns = (props) => {
  const technicienColumns: any = [
    {
      name: props.t('username'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('first_name'),
      selector: (row) => row.nom,
      sortable: true,
      center: true,
    },
    {
      name: props.t('last_name'),
      selector: (row) => row.prenom,
      sortable: true,
      center: true,
    },
    {
      name: props.t('email'),
      selector: (row) => row.email,
      sortable: true,
      center: true,
    },
    {
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={technicienColumns} data={props.data} />;
};
export default translate(TechnicianColumns);
